import React from "react";
import Button from "ComponentsUI/Button";

const TariffOrderButton = (props) => {
	return (
		<Button
			status={"orange"}
			noPaddings={true}
			onClick={props.clickHandler}
			fullWidth={true}
			className={props.className}
		>
			{props.text}
		</Button>
	);
};

export default TariffOrderButton;
